"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _reactPortal = require("react-portal");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _isFunction = _interopRequireDefault(require("lodash/isFunction"));

var _reactTransitionGroup = require("react-transition-group");

var _classnames = _interopRequireDefault(require("classnames"));

var _DarkDropdownPopup = _interopRequireDefault(require("./DarkDropdownPopup.style"));

var _calculatePosition = _interopRequireDefault(require("./calculatePosition"));

/* eslint-disable no-confusing-arrow */
var transitionStyles = {
  entering: {
    transition: 'transform 300ms cubic-bezier(0.075, 0.82, 0.165, 1), opacity 300ms cubic-bezier(0.075, 0.82, 0.165, 1)',
    opacity: '0',
    transform: 'scaleY(0.6)'
  },
  entered: {
    transition: 'transform 300ms cubic-bezier(0.075, 0.82, 0.165, 1), opacity 300ms cubic-bezier(0.075, 0.82, 0.165, 1)',
    opacity: '1'
  },
  exiting: {
    transition: 'transform 300ms cubic-bezier(0.075, 0.82, 0.165, 1), opacity 300ms cubic-bezier(0.075, 0.82, 0.165, 1)',
    opacity: '0',
    transform: 'scaleY(0.6)'
  }
};

var DarkDropdownPopup =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(DarkDropdownPopup, _Component);

  function DarkDropdownPopup(props) {
    var _this;

    (0, _classCallCheck2.default)(this, DarkDropdownPopup);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(DarkDropdownPopup).call(this, props));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "setPopupPosition", function () {
      var _this$props = _this.props,
          wrapNode = _this$props.wrapNode,
          placement = _this$props.placement,
          popupWidth = _this$props.popupWidth,
          popupNode = _this$props.popupNode,
          parentNode = _this$props.parentNode;
      setTimeout(function () {
        var positionStyle = (0, _calculatePosition.default)(wrapNode, placement, popupWidth, popupNode, parentNode);

        _this.setState({
          top: positionStyle.top,
          left: positionStyle.left
        });
      }, 0);
    });
    _this.state = {
      top: 0,
      left: 0
    };
    return _this;
  }

  (0, _createClass2.default)(DarkDropdownPopup, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      if (this.props.showPopup) {
        setTimeout(function () {
          _this2.setPopupPosition();
        }, 0);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.setPopupPosition();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          popupNode = _this$props2.popupNode,
          content = _this$props2.content,
          close = _this$props2.close,
          popupWrapperClassName = _this$props2.popupWrapperClassName,
          popupWidth = _this$props2.popupWidth,
          showPopup = _this$props2.showPopup,
          popupCustomStyle = _this$props2.popupCustomStyle,
          placement = _this$props2.placement;
      var _this$state = this.state,
          top = _this$state.top,
          left = _this$state.left;
      return _react.default.createElement(_reactPortal.Portal, {
        node: popupNode
      }, _react.default.createElement(_reactTransitionGroup.Transition, {
        timeout: 300,
        in: showPopup
      }, function (state) {
        return state === 'exited' ? null : _react.default.createElement("div", {
          className: (0, _classnames.default)((0, _DarkDropdownPopup.default)(placement, popupWidth || 375), popupWrapperClassName) // eslint-disable-next-line max-len
          ,
          style: (0, _objectSpread2.default)({
            top: top,
            left: left
          }, transitionStyles[state], popupCustomStyle)
        }, (0, _isFunction.default)(content) ? content(close) : content);
      }));
    }
  }]);
  return DarkDropdownPopup;
}(_react.Component);

DarkDropdownPopup.defaultProps = {
  popupCustomStyle: {}
};
DarkDropdownPopup.propTypes = {
  popupNode: _propTypes.default.instanceOf(HTMLElement).isRequired,
  content: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.func]).isRequired,
  close: _propTypes.default.func.isRequired,
  popupCustomStyle: _propTypes.default.object
};
var _default = DarkDropdownPopup;
exports.default = _default;